module.exports = __webpack_public_path__ + "static/bg-contact-6f421ad68dc74f525b4f688dde0b338e.png";